export class AggregationSelector {
    constructor(public readonly id: string, public readonly name: string, public data: Aggregation) {

    }
}

export class Aggregation {
    constructor(public sum: boolean, public avg: boolean, public min: boolean, public max: boolean ){

    }
}




// WEBPACK FOOTER //
// ./src/app/stocks/models/aggregation-selector.ts